import { render, staticRenderFns } from "./father.vue?vue&type=template&id=c1be98d2&scoped=true&"
import script from "./father.vue?vue&type=script&lang=js&"
export * from "./father.vue?vue&type=script&lang=js&"
import style0 from "./father.vue?vue&type=style&index=0&id=c1be98d2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1be98d2",
  null
  
)

export default component.exports